import React from 'react';

import { Button } from '../../Button';
import { DropdownButton } from '../../Dropdown-button';
import { LanguageItemType } from '../types';
import { useKeyboardShortcut } from '../../../Lib/KeyboardShortcuts/hooks/useKeyboardShortcut';

const languageItems = [
    {
        label: 'English',
        classname: 'mt-m',
        iconBefore: 'english_language',
        ariaLabel: 'english',
        shortLanguage: 'En'
    },
    {
        label: 'Français',
        classname: 'my-m',
        iconBefore: 'french_language',
        ariaLabel: 'français',
        shortLanguage: 'Fr'
    },
    {
        label: 'Deutsch',
        classname: 'mb-m',
        iconBefore: 'deutsch_language',
        ariaLabel: 'deutsch',
        shortLanguage: 'De'
    }
];

function LanguageSelector(props: { onClickLanguageSelector?: (event: MouseEvent) => void, keyboardShortcut: boolean }) {
    const { onClickLanguageSelector, keyboardShortcut, ...rest } = props;

    const [dropdownLabel, setDropdownLabel] = React.useState('En');
    const languageRef = React.useRef<HTMLDivElement | null>(null);

    if (keyboardShortcut) {
        useKeyboardShortcut({
            id: 'HEADER_LANGUAGE',
            handler: () => {
                languageRef.current?.click();
                languageRef.current?.focus();
            },
        });
    }

    return <DropdownButton
        theme="tertiary-phantom"
        aria-label="switch language"
        buttonClassName="h-100"
        className="h-100 d-flex align-items-center"
        style={{ width: '60px' }}
        styleListContainer={{
            width: '300px',
        }}
        callToClose={event}
        onItemSelect={(item: any) => console.log('selected item', item)}
        nestedComponent={
            <div className="bg px-s d-flex flex-column">
                {languageItems.map((item: LanguageItemType) =>
                    <Button
                        key={item.label}
                        className={item.classname}
                        theme="tertiary-phantom"
                        iconBefore={item.iconBefore}
                        aria-label={item.ariaLabel}
                        onClick={(event: any) => {
                            setDropdownLabel(item.shortLanguage);
                            onClickLanguageSelector && onClickLanguageSelector(event);
                        }}
                    >
                        {item.label}
                    </Button>)
                }
            </div>
        }
    >
        <div ref={languageRef}>{dropdownLabel}</div>
    </DropdownButton>
}

export default LanguageSelector;